module.exports = __webpack_public_path__ + "static/media/20240130082506_IMG_5064 (1).2610f80c.jpg";